import { GenIcon } from '../helpers/IconBase.es.js';

const ShieldOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M20 11.1821C20 15.7231 16.587 19.9691 12 21.0001C7.413 19.9691 4 15.7231 4 11.1821V7.61508C4.00004 7.21801 4.11827 6.82994 4.33963 6.5003C4.561 6.17066 4.87547 5.91437 5.243 5.76408L10.243 3.71808C11.369 3.25706 12.631 3.25706 13.757 3.71808L18.757 5.76408C19.1245 5.91437 19.439 6.17066 19.6604 6.5003C19.8817 6.82994 20 7.21801 20 7.61508V11.1821Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M15.25 10.125L11.5 13.875L9.25 11.625",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { ShieldOutlined };
